interface KBSkeletonProps {
    variant?: 'home' | 'category' | 'article' | 'search'
}

const Pulse = ({
    className = '',
    style,
}: {
    className?: string
    style?: React.CSSProperties
}) => (
    <div
        className={`kb-skeleton-pulse ${className}`}
        style={style}
    />
)

const KBSkeleton = ({ variant = 'home' }: KBSkeletonProps) => {
    if (variant === 'home') {
        return (
            <div className="kb-skeleton">
                <div className="kb-skeleton__hero">
                    <Pulse style={{ width: 160, height: 28, borderRadius: 20, marginBottom: 16 }} />
                    <Pulse style={{ width: 340, height: 36, borderRadius: 8, marginBottom: 12 }} />
                    <Pulse style={{ width: 280, height: 18, borderRadius: 8, marginBottom: 24 }} />
                    <Pulse style={{ width: '100%', maxWidth: 520, height: 48, borderRadius: 24 }} />
                </div>
                <div className="kb-skeleton__grid">
                    {Array.from({ length: 8 }).map((_, i) => (
                        <div key={i} className="kb-skeleton__card">
                            <Pulse style={{ width: 48, height: 48, borderRadius: 12, marginBottom: 12 }} />
                            <Pulse style={{ width: '70%', height: 18, borderRadius: 6, marginBottom: 8 }} />
                            <Pulse style={{ width: '100%', height: 14, borderRadius: 6, marginBottom: 6 }} />
                            <Pulse style={{ width: '60%', height: 14, borderRadius: 6 }} />
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    if (variant === 'category') {
        return (
            <div className="kb-skeleton">
                <Pulse style={{ width: 200, height: 16, borderRadius: 6, marginBottom: 24 }} />
                <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 32 }}>
                    <Pulse style={{ width: 48, height: 48, borderRadius: 12 }} />
                    <div>
                        <Pulse style={{ width: 220, height: 24, borderRadius: 6, marginBottom: 8 }} />
                        <Pulse style={{ width: 320, height: 14, borderRadius: 6 }} />
                    </div>
                </div>
                {Array.from({ length: 4 }).map((_, i) => (
                    <div key={i} style={{ marginBottom: 16 }}>
                        <Pulse style={{ width: '100%', height: 100, borderRadius: 12 }} />
                    </div>
                ))}
            </div>
        )
    }

    if (variant === 'article') {
        return (
            <div className="kb-skeleton">
                <Pulse style={{ width: 260, height: 16, borderRadius: 6, marginBottom: 24 }} />
                <Pulse style={{ width: '70%', height: 32, borderRadius: 8, marginBottom: 16 }} />
                <div style={{ display: 'flex', gap: 16, marginBottom: 32 }}>
                    <Pulse style={{ width: 100, height: 14, borderRadius: 6 }} />
                    <Pulse style={{ width: 140, height: 14, borderRadius: 6 }} />
                </div>
                {Array.from({ length: 6 }).map((_, i) => (
                    <Pulse
                        key={i}
                        style={{
                            width: `${70 + Math.random() * 30}%`,
                            height: 14,
                            borderRadius: 6,
                            marginBottom: 12,
                        }}
                    />
                ))}
            </div>
        )
    }

    return (
        <div className="kb-skeleton">
            <Pulse style={{ width: 200, height: 16, borderRadius: 6, marginBottom: 24 }} />
            <Pulse style={{ width: 240, height: 28, borderRadius: 8, marginBottom: 12 }} />
            <Pulse style={{ width: 180, height: 14, borderRadius: 6, marginBottom: 32 }} />
            {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} style={{ marginBottom: 16 }}>
                    <Pulse style={{ width: '100%', height: 90, borderRadius: 12 }} />
                </div>
            ))}
        </div>
    )
}

export default KBSkeleton
